import React, { useEffect, useState, useRef, useMemo} from "react";
import { Link as ScrollLink} from "react-scroll";
import styles from "./stylesComponent/NavBar.module.css";
import { AiOutlineMenu } from "react-icons/ai";
import { AiOutlineClose } from "react-icons/ai";
import { FaShoppingCart } from "react-icons/fa";
import { useScrollPosition } from "../../Hooks/scrollPosition";
import { TbLogin2 } from "react-icons/tb";
import { DiAptana } from "react-icons/di";
import { SiGoogleclassroom } from "react-icons/si";
import { FaCirclePlay } from "react-icons/fa6";
import { IoIosNotifications } from "react-icons/io";
import { IoMdMail } from "react-icons/io";
import { FaSearch } from "react-icons/fa";
import { MdDarkMode } from "react-icons/md";
import { MdLightMode } from "react-icons/md";
import {Link} from 'react-router-dom';
import { TbLogout2 } from "react-icons/tb";
import { MdOutlineMail } from "react-icons/md";
import { CiBoxList } from "react-icons/ci";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import useSWR from "swr";
import { getLastSeen, updateLastSeenToNow } from "../../Hooks/ultimaVista";
import { DetalleMensajeDialog } from "../Mensajes";
import { useCarrito } from './Cart';
import CartDropdown from './CartDropdown';
import logoDark from '../../resources/images/LogoAppDarkMode.png';
import logoLight from '../../resources/images/LogoAppLightMode.png';
import { ComponerMensajeDialog } from '../Mensajes';
import Swal from 'sweetalert2';
import $ from "jquery";

//Menú anidado
const MenuItem = ({ item, setNavBarOpen, setInput, setConsulta, level = 0}) => {
    const [open, setOpen] = useState(false);
    const [submenuTop, setSubmenuTop] = useState(0);
    const itemRef = useRef(null);

    // Se activa al entrar con el ratón y se muestra el submenú.
    const handleMouseEnter = () => {
        if(itemRef.current){
            setSubmenuTop(itemRef.current.offsetTop);
        }
        setOpen(true);
    };


    // Oculta el submenú al salir el ratón.
    const handleMouseLeave = () => {
        setOpen(false);
    };

    return(
        <div ref={itemRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <Link
                to={{ pathname: "/Contenido", state: {filtro_inicial: "tematicas", tematicas_inicial: item.link} }}
                className={styles.navLink}
                onClick={() => { setNavBarOpen(false); setInput(""); setConsulta(""); }}
                smooth
                duration={500}
            >
                {item.link}
            </Link>
            <div className={styles.border}></div>

                {item.children && item.children.length > 0 && open && (
                    <div className={styles.subMenu} style={{top: submenuTop, left: level === 0 ? "75%" : "95%"}}>
                        {item.children.map((child) => (
                            <MenuItem key={child.id} item={child} setNavBarOpen={setNavBarOpen} setInput={setInput} setConsulta={setConsulta} level={level + 1} />
                        ))}
                    </div>
                )}
            </div>   
    );
};

//Consulta para búsqueda usando caché
const busqueda = async ([uUrl, cUrl, coUrl]) => {
    const [uRes, cRes, coRes] = await Promise.all([
      fetch(uUrl).then(r => r.json()),
      fetch(cUrl).then(r => r.json()),
      fetch(coUrl).then(r => r.json()),
    ]);
    return [uRes, cRes, coRes];
};


const NavBar = () => {
    const location = useLocation();
    const navRef = useRef(null);
    const { carrito } = useCarrito();

    useEffect(() => {
        if (navRef.current) {
            $(navRef.current).hide().slideDown(400);
        }
        return () => {
            if (navRef.current) {
                $(navRef.current).stop(true, true).show();
            }
        };
    }, []);

    const [theme, setTheme] = useState(() => {
        return localStorage.getItem('app-theme') || 'dark';
    });

    useEffect(() => {
        document.documentElement.classList.remove('light-mode', 'dark-mode');
        document.documentElement.classList.add(`${theme}-mode`);
        localStorage.setItem('app-theme', theme);
    }, [theme]);

  //Función para alternar
    const toggleTheme = () => {
        setTheme(prev => (prev === 'dark' ? 'light' : 'dark'));
    };

    //cambiar clases de menú
    const [navBarOpen, setNavBarOpen] = useState(false)
    const [activeMenu, setActiveMenu] = useState(null)
    const [usuario, setUsuario] = useState(() => {
        const usuarioAlmacenado = localStorage.getItem("userLogueado");
        return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : null;
    })
    const [role, setRole] = useState("");

    //Estados para notificaciones
    const [mensajesNuevos, setMensajesNuevos] = useState([]);
    const [loadingNotifs, setLoadingNotifs] = useState(false);
    const [errorNotifs, setErrorNotifs] = useState(null);

    const [detalleMensaje, setDetalleMensaje] = React.useState({
        abierto: false,
        datos: null,
    });

    const [compose, setCompose] = useState({ abierto: false, inicial: {} });

    let baseUrl;
    if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
    else baseUrl='https://app-formacion.vercel.app';

    //Función para comprobar nuevos mensajes
    const checkNewMessages = async () => {
    if (!usuario) return;
        const sinceIso = getLastSeen(usuario._id);
        if (!sinceIso) return;
        setLoadingNotifs(true);
        try {
        const res = await fetch(
            `${baseUrl}/api/mensajes/nuevos/${usuario._id}?since=${sinceIso}`
        );
        if (!res.ok) throw new Error("Error al obtener mensajes nuevos");
        const data = await res.json();
        setMensajesNuevos(Array.isArray(data) ? data : data.mensajes || []);
        } catch (err) {
        console.error(err);
        setErrorNotifs("No se pudieron cargar las notificaciones");
        } finally {
        setLoadingNotifs(false);
        }
    };

   //Al cargar/montar o cambiar usuario
    useEffect(() => {
        if (usuario) checkNewMessages();
    }, [usuario]);

    //Al cambiar de ruta
    useEffect(() => {
        if (usuario) checkNewMessages();
        // cerrar menús de búsqueda al cambiar página
        setActiveMenu(null);
        setInput(""); setConsulta("");
    }, [location.pathname]);

  //Al abrir el menú de notificaciones
  useEffect(() => {
    if (activeMenu === "notify" && usuario) {
      checkNewMessages();
    }
  }, [activeMenu, usuario]);

    useEffect(() => {
        if (usuario) {
        // Obtener la última fecha guardada
        const sinceIso = getLastSeen(usuario._id);

        // Si existe esa fecha, pedimos al backend los mensajes nuevos
        if (sinceIso) {
            setLoadingNotifs(true);
            fetch(`${baseUrl}/api/mensajes/nuevos/${usuario._id}?since=${sinceIso}`)
            .then(res => {
                if (!res.ok) throw new Error("Error al obtener mensajes nuevos");
                return res.json();
            })
            .then(data => {
                // Ajusta según la estructura que devuelva tu API
                const arr = Array.isArray(data) ? data : data.mensajes || [];
                setMensajesNuevos(arr);
            })
            .catch(err => {
                console.error(err);
                setErrorNotifs("No se pudieron cargar las notificaciones");
            })
            .finally(() => {
                setLoadingNotifs(false);
            });
        }
        // Si no hay fecha anterior (primer login), no mostrar nada.
        }
    }, [usuario]);

    const handleShowDetail = async (msgId) => {
    try {
        const res = await fetch(`${baseUrl}/api/mensajes/${msgId}`);
        if (!res.ok) throw new Error('No encontrado');
        const fullMsg = await res.json();
        setDetalleMensaje({ abierto: true, datos: fullMsg });

        // Quitar el mensaje abierto del badge
        setMensajesNuevos(prev => prev.filter(m => m._id !== msgId));
        updateLastSeenToNow(usuario._id);
        setMensajesNuevos([]);
    } catch (err) {
        console.error(err);
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error al cargar el mensaje',
            confirmButtonText: 'Cerrar'
        });
    }
    };

    const handleDetalleClose = () => {
        setDetalleMensaje({ abierto: false, datos: null });
    };

    useEffect(() => {
        if (usuario !== null) {
          if (usuario.Tipo === "Cliente") {
            setRole("/cliente");
          } else if (usuario.Tipo === "Tutor") {
            setRole("/tutor");
          } else {
            setRole("/admin");
          }
        }
    }, [usuario]);

    useEffect(() => {
        // Si se abre el menú de notificaciones y hay un usuario logueado:
        if (activeMenu === "notify" && usuario) {
            const fetchNuevos = async () => {
                setLoadingNotifs(true);
                setErrorNotifs(null);

                const fechaDesconexion = getLastSeen(usuario._id);

                if (!fechaDesconexion) {
                    setMensajesNuevos([]);
                    setLoadingNotifs(false);
                    return;
                }

                try {  
                    const res = await fetch(
                        `${baseUrl}/api/mensajes/nuevos/${usuario._id}?since=${fechaDesconexion}`
                    );
                    if (!res.ok) {
                        throw new Error("Error al obtener mensajes nuevos");
                    }
                    const data = await res.json();
                    setMensajesNuevos(Array.isArray(data) ? data : data.mensajes || []);
                } catch (err) {
                    console.error(err);
                    setErrorNotifs("No se pudieron cargar las notificaciones");
                } finally {
                    setLoadingNotifs(false);
                }
            };

            fetchNuevos();
        }
    }, [activeMenu, usuario]);


    let links;
       
    if(usuario !== null && Array.isArray(usuario.Tematicas) && usuario.Tematicas.length > 0){
        if(usuario.Tematicas.length !== 0){
            links = [];
            for(let i=0;i<usuario.Tematicas.length;i++){
                links.push({id: i, link: usuario.Tematicas[i],});
            }
        }
    }
    else{
        links = [
            {id: 1, link: "Programación", children: [
                    {id: 1, link: "Programación web"},
                    {id: 2, link: "Programación de aplicaciones móviles"},
                    {id: 3, link: "Lenguajes de programación", children: [
                        {id: 1, link: "Java"},
                        {id: 2, link: "C++"},
                        {id: 3, link: "Python"},
                        {id: 4, link: "JavaScript"},
                        {id: 5, link: "Php"},
                    ]},
                ],
            },
            {id: 2, link: "Emprendimiento", children: [
                {id: 1, link: "Comunicación"},
                {id: 2, link: "Ventas"},
                {id: 3, link: "Negocios"},
                {id: 4, link: "Gestión de Proyectos"},
                {id: 5, link: "Recursos Humanos"},
                {id: 6, link: "Comercio electrónico"},
            ]},
            {id: 3, link: "Finanzas", children: [
                {id: 1, link: "Contabilidad"},
                {id: 2, link: "Economía"},
                {id: 3, link: "Inversión"},
            ]},
            {id: 4, link: "Informática", children: [
                {id: 1, link: "Ofimática"},
                {id: 2, link: "Hardware"},
                {id: 3, link: "IA"},
            ]},
            {id: 5, link: "Desarrollo Personal",children: []},
            {id: 6, link: "Diseño", children: [
                {id: 1, link: "Diseño Gráfico"},
                {id: 2, link: "Diseño 3D y animación"},
                {id: 3, link: "Diseño de moda"},
                {id: 4, link: "Diseño arquitectónico"},
                {id: 5, link: "Diseño de interiores"},
            ]},
            {id: 7, link: "Marketing", children: [
                {id: 1, link: "Marketing Digital"},
                {id: 2, link: "Marca Personal"},
            ]},
            {id: 8, link: "Arte y manualidades", children: [
                {id: 1, link: "Pintura"},
                {id: 2, link: "Dibujo"},
                {id: 3, link: "Cocina"},
                {id: 4, link: "Fotografía y vídeo"},
                {id: 5, link: "Música"},
            ]},
            {id: 9, link: "Deporte y fitness", children: [
                {id: 1, link: "Nutrición"},
            ]},
            {id: 10, link: "Ciencias", children: [
                {id: 1, link: "Ingeniería"},
                {id: 2, link: "Física"},
                {id: 3, link: "Química"},
                {id: 4, link: "Biología"},
                {id: 5, link: "Geología"},
                {id: 6, link: "Matemáticas"},
            ]},
            {id: 11, link: "Idiomas", children: [
                {id: 1, link: "Idioma Ingés"},
                {id: 2, link: "Idioma Español"},
                {id: 3, link: "Idioma Francés"},
                {id: 4, link: "Idioma Alemán"},
                {id: 5, link: "Idioma Ruso"},
                {id: 6, link: "Idioma Chino"},
                {id: 7, link: "Idioma Árabe"},
                {id: 8, link: "Idioma Japonés"},
            ]},
            {id: 12, link: "Ciencias Sociales", children: [
                {id: 1, link: "Psicología"},
                {id: 2, link: "Historia"},
                {id: 3, link: "Historia del arte"},
                {id: 4, link: "Geografía"},
            ]},
            {id: 13, link: "Humanidades", children: [
                {id: 1, link: "Lengua y literatura"},
                {id: 2, link: "Filosofía"},
            ]},
            {id: 14, link: "Formación de profesorado", children: [
                {id: 1, link: "Preparación para examenes oficiales"},
            ]},
        ];
    }
    
    //LogOut
    const cerrarSesion = () => {
        if (usuario) {
            updateLastSeenToNow(usuario._id);
        }
        localStorage.removeItem("userLogueado");
        setUsuario(null);
        window.location.href = "/"; // Redirige a la página de login
    }
    
    const scrollPosition = useScrollPosition();

    //Abrir menú de los iconos del nav
    const toggleMenu = (menu) => {
        if(activeMenu === menu){
            //if(menu==="notify" && usuario){
                //updateLastSeenToNow(usuario._id);
               // setMensajesNuevos([]);
           // }
            setActiveMenu(null);
        }
        else{
            setActiveMenu(menu);
            if (menu === "notify") {
                setDetalleMensaje({ abierto: false, datos: null });
            }
        }

        // Oculta el cuadro de búsqueda
        setInput("");
        setConsulta("");
    };

    const normalize = (s) =>
    typeof s === "string"
        ? s
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/\s+/g, " ")
            .trim()
        : "";

    //Realizar Busqueda
    const [consulta, setConsulta] = useState("");
    const [input, setInput] = useState("");

    const rawTerm =  input.trim().toLowerCase();
    const puedoBuscar = rawTerm.length >= 3;
    
    const encodedTerm = encodeURIComponent(rawTerm);

    const normalizedTerm = normalize(rawTerm);
    
    //Lanzar consulta 
    let urls = puedoBuscar
    ? [
        `${baseUrl}/api/users/search/name/${encodedTerm}`,
        `${baseUrl}/api/clases/search/name/${encodedTerm}`,
        `${baseUrl}/api/cursos/search/name/${encodedTerm}`,
      ]
    : null;

    //Usamos SWR con esa key condicional
    const { data: raw = [[], [], []], error, isValidating } = useSWR(urls, busqueda, {
        dedupingInterval: 30 * 60 * 1000,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        revalidateOnMount: false,
        keepPreviousData: true,
    });

    const [usuariosData, clasesData, cursosData] = raw;

    const resultadosUsuario = useMemo(() => {
        if (!puedoBuscar) return [];
        const users = Array.isArray(usuariosData) ? usuariosData : [];
        return users.filter(u => {
            if (u.Tipo !== "Tutor") return false;
            return (
            normalize(u.Nombre).includes(normalizedTerm) ||
            normalize(u.Apellidos).includes(normalizedTerm) ||
            // normalize(u.Correo).includes(normalizedTerm) ||
            normalize(u.Usuario).includes(normalizedTerm)
            );
        });
    }, [usuariosData, normalizedTerm, puedoBuscar]);

    const resultadosClases = useMemo(() => {
        if (!puedoBuscar) return [];
        const clases = Array.isArray(clasesData) ? clasesData : [];
        return clases
            .filter(cl => normalize(cl.Nombre).includes(normalizedTerm))
            .map(clase => ({
            ...clase,
            tipo: clase.Particular ? "claseParticular" : "clase",
            }));
    }, [clasesData, normalizedTerm, puedoBuscar]);

    const resultadosCursos = useMemo(() => {
        if (!puedoBuscar) return [];
        const cursos = Array.isArray(cursosData) ? cursosData : [];
        return cursos
            .filter(cu => normalize(cu.Nombre).includes(normalizedTerm))
            .map(curso => ({ ...curso, tipo: "curso" }));
    }, [cursosData, normalizedTerm, puedoBuscar]);
    

    const manejarConsulta = (value) => {
        setInput(value);
        setConsulta(value);
               
        // Cerrar cualquier menú abierto al escribir en el input
        if (activeMenu) {
            setActiveMenu(null);
        }
    }

    //Cerrar cuadro de búsqueda cuando se cambia de localización
    useEffect(() => {
        setActiveMenu(null);
        setInput("");
        setConsulta("");
      }, [location.pathname]);

    //Detectar clicks fuera del navbar para cerrar menús de iconos del navbar
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (detalleMensaje.abierto) {
                return;
            }

            if(compose.abierto){
                return;
            }

            if (navRef.current && !navRef.current.contains(e.target)) {
                // Si el clic NO está dentro de navRef, cerramos activeMenu
                setActiveMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [detalleMensaje.abierto]);

    return (
        <div 
            ref={navRef}
            className = { 
                navBarOpen 
                    ? styles.navOpen
                    : scrollPosition > 0
                    ? styles.navOnScroll
                    : styles.navBar
        }
        >
            {!navBarOpen ? (
                <AiOutlineMenu
                    style={{ marginLeft: '20px' }}
                    color='var(--color-iconos-nav)'
                    onClick={() => setNavBarOpen(!navBarOpen)}
                    size={25}
                />
            ) : (
            (
                <AiOutlineClose
                    onClick={() => setNavBarOpen(!navBarOpen)}
                    color='var(--color-iconos-nav)'
                    size={25}
                />
            )
            )}
            
            {!navBarOpen && !usuario ? (
                <p className={styles.logo}>
                    <Link className={styles.logoLink} to="/" onClick={() => {setInput(""); setConsulta("");}}>
                        <img className={styles.logoImg} src={theme === 'dark' ? logoDark : logoLight} alt={`logo Aplicación`} /> 
                        <span>App-Formación</span>
                    </Link>
                </p> ) : (
                    <p className={styles.logo}>
                        <Link className={styles.logoLink} to={role}  onClick={() => {setInput(""); setConsulta("");}}>
                            <img className={styles.logoImg} src={theme === 'dark' ? logoDark : logoLight} alt={`logo Aplicación`} />
                            <span>App-Formación</span>
                        </Link>
                    </p>
                )
            }

            {!navBarOpen && (
                <div className={styles.iconosNav}>
                    <div className={styles.inputWrapper}>
                        <FaSearch className={styles.searchIcon} />
                        <input type="text" placeholder="Escribe para buscar..." value={input} onChange={(e) => manejarConsulta(e.target.value)}/>
                    </div>
                    <button onClick={() => toggleMenu("cart")}>
                        <FaShoppingCart  size={22} />
                        {carrito.length > 0 && <span className={styles.badgeCart}>{carrito.length}</span>}
                    </button>
                    <button onClick={() => toggleMenu("config")}>
                        <DiAptana size={22} />
                    </button>
                    {usuario && (
                        <button onClick={() => toggleMenu("notify")} className={styles.notifyBoton}>
                            <IoIosNotifications size={22} />
                                {mensajesNuevos.length > 0 && ( 
                                    <span className={styles.badge}>
                                        <IoMdMail size={11} />
                                    </span>
                                )}
                        </button>
                    )}
                    {!usuario ? (
                        <Link to="/login" onClick={() => {setInput(""); setConsulta("");}} style={{marginTop: '3px'}}>
                            <TbLogin2 size={22} />
                        </Link> 
                    ) : (
                        <button onClick={() => toggleMenu("user")}>
                            <img src={`data:image/jpeg;base64,${usuario.ImagenPerfil}`} alt="Imagen de perfil" className={styles.perfilImagen} />
                        </button>
                    )}
                </div>
            )}
            {/*Contenedor de resultados de búsqueda */}
            {!navBarOpen && input && puedoBuscar && (
                <div className={styles.searchResults} style={{ left: usuario ? '1020px' : '1082px'}}>
                    {Array.isArray(resultadosUsuario) && resultadosUsuario.length > 0 && (
                        <div className={styles.resultsSection}>
                            {resultadosUsuario.map((user) => (
                                <Link to={{ pathname: `/detalleTutor/${user._id}`, state: { tutor: user }}} onClick={() => {setInput(""); setConsulta("");}} style={{color:"black", textDecoration: "none" }}> 
                                    <div key={user.id} className={styles.resultItem}>
                                        <div className={styles.lineaUsuario}>
                                            <img src={`data:image/jpeg;base64,${user.ImagenPerfil}`} alt={`${user.Nombre} ${user.Apellidos}`} className={styles.resultImage}/>
                                            <span className={styles.resNombreUsuario}>
                                                {user.Nombre} {user.Apellidos}
                                            </span> 
                                        </div>
                                        <span className={styles.resUsuario}>
                                            {user.Usuario}
                                        </span>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    )}

                    {Array.isArray(resultadosClases) && resultadosClases.length > 0 && (
                         <div className={styles.resultsSection}>
                         {resultadosClases.map((clase) => (
                            <Link to={{ pathname: `/detalleContenido/${clase._id}`, state: { producto: clase, tutor: clase.tutorContenido } }} onClick={() => {setInput(""); setConsulta("");}}  style={{color:"black"}}> 
                                <div key={clase.id} className={styles.resultItem2}>
                                    <SiGoogleclassroom />
                                    <span title={clase.Nombre}>{clase.Nombre}</span>
                                </div>
                           </Link>
                         ))}
                       </div>
                    )}

                    {Array.isArray(resultadosCursos) && resultadosCursos.length > 0 && (
                         <div className={styles.resultsSection}>
                         {resultadosCursos.map((curso) => (
                            <Link to={{ pathname: `/detalleContenido/${curso._id}`, state: { producto: curso, tutor: curso.tutorContenido } }} onClick={() => {setInput(""); setConsulta("");}}  style={{color:"black"}}>
                                <div key={curso.id} className={styles.resultItem2}>
                                    <FaCirclePlay />
                                    <span title={curso.Nombre}>{curso.Nombre}</span>
                                </div>
                           </Link>
                         ))}
                       </div>
                    )}

                </div>
            )}

            {!navBarOpen && activeMenu === "config" &&  (
                <div className={styles.configOpen}>
                    <ul style={{listStyle: 'none', textAlign: 'center'}}>
                        <li>
                            <button onClick={toggleTheme}>
                                {theme === 'dark' 
                                    ? <MdLightMode size={22} style={{color: 'black'}} /> 
                                    : <MdDarkMode size={22} style={{color: 'black'}} />}
                            </button>
                        </li>
                        {usuario && (
                            <li><Link to="/configurarPerfil" style={{color: 'black', fontSize: '18px'}}>Configurar perfil</Link></li>
                        )}
                    </ul>
                </div>
            )}

             {!navBarOpen && activeMenu === "cart"  && <CartDropdown />}
                {/*<div className={styles.cartOpen}>
                    <ul style={{listStyle: 'none', textAlign: 'center'}}>
                        <li><p>Su cesta está vacia</p></li>
                    </ul>
                </div>
            )}*/}

            {!navBarOpen && activeMenu === "notify"  && usuario && (
                <div className={styles.notifyOpen}>
                     <ul style={{ listStyle: "none", textAlign: "center", padding: 0 }}>
                        {loadingNotifs && (
                            <li>
                                <p style={{fontSize: "18px"}}>Cargando notificaciones…</p>
                            </li>
                        )}
                        {errorNotifs && (
                            <li>
                                <p style={{ color: "red" }}>{errorNotifs}</p>
                            </li>
                        )}

                        {!loadingNotifs && !errorNotifs && mensajesNuevos.length === 0 && (
                            <li>
                                <p style={{fontSize: "18px"}}>No tienes notificaciones</p>
                            </li>
                        )}

                        {!loadingNotifs &&
                            mensajesNuevos.length > 0 &&
                            mensajesNuevos.map((msj) => {
                                const remitenteEliminado = !msj.remitente;
                                return (
                                    <li key={msj._id} onClick={() => handleShowDetail(msj._id)} className={styles.notifyItem}>
                                        <div className={styles.notifyHeader}>
                                            <strong>
                                                {remitenteEliminado ? (
                                                    <span style={{ fontStyle: "italic", color: "#888" }}>
                                                        Usuario eliminado
                                                    </span>
                                                ) : msj.remitente 
                                                } : </strong>
                                        </div>
                                        <div className={styles.notifyBody}>
                                            <span>{msj.Asunto}</span>
                                        </div>
                                    </li>
                                )
                            })}
                    </ul>
                    <DetalleMensajeDialog
                        abierto={detalleMensaje.abierto}
                        mensaje={detalleMensaje.datos}
                        onClose={(action) => {
                            if (action?.reply) {
                                setCompose({ abierto: true, inicial: { ...detalleMensaje.datos, respuestaA: detalleMensaje.datos._id } });
                            }
                                setDetalleMensaje({ abierto: false, datos: null });
                        }}
                        onShowDetail={handleShowDetail}
                        BackdropProps={{
                            onMouseDown: e => e.stopPropagation(),
                        }}
                        PaperProps={{
                            onMouseDown: e => e.stopPropagation(),
                        }}
                    />
                     <ComponerMensajeDialog
                        abierto={compose.abierto}
                        inicial={compose.inicial}
                        onClose={() => setCompose({ abierto: false, inicial: {} })}
                    />
                </div>
            )}  
             {!navBarOpen && usuario && activeMenu === "user"  && (
                <div className={styles.LogoutOpen}>
                    <ul style={{listStyle: 'none', textAlign: 'center'}}>
                        <li><button style={{color: "black"}} onClick={cerrarSesion}><span style={{fontSize: '18px'}}> <TbLogout2 size={18} /> Cerrar sesión</span></button></li>
                    </ul>
                </div>
            )} 


            {navBarOpen && (
            <ul className={styles.linksContainer}>
                <li><Link to={{ pathname: "/Contenido", state: { filtro_inicial: "todo" } }} style={{color: 'var(--color-letras-nav)', fontweight: "400", fontsize: "1.2em"}} onClick={() => {setNavBarOpen(false); setInput(""); setConsulta("");}}>Todos los contenidos</Link></li>
                <li><Link to={{ pathname: "/Contenido", state: { filtro_inicial: "cursos" } }} style={{color: 'var(--color-letras-nav)', fontweight: "400", fontsize: "1.2em"}} onClick={() => {setNavBarOpen(false); setInput(""); setConsulta("");}}>Cursos</Link></li>
                <li><Link to={{ pathname: "/Contenido", state: { filtro_inicial: "clases" } }} style={{color: 'var(--color-letras-nav)', fontweight: "400", fontsize: "1.2em"}} onClick={() => {setNavBarOpen(false); setInput(""); setConsulta("");}}>Clases</Link></li>
                <li><Link to={{ pathname: "/Tutores" }} style={{color: 'var(--color-letras-nav)', fontweight: "400", fontsize: "1.4em"}} onClick={() => {setNavBarOpen(false); setInput(""); setConsulta("");}}>Tutores</Link></li>
                {usuario && usuario.Tematicas.length !== 0 ? ( <p style={{color: 'var(--color-letras-nav)', paddingTop: "15px", fontweight: "400", fontSize: "1.2em"}}>Temáticas Seleccionadas</p>
                ) : ( <p style={{color: 'var(--color-letras-nav)', paddingTop: "15px", fontweight: "400", fontSize: "1.2em"}}>Temáticas populares</p>
                )}
                {usuario && usuario.Tematicas.length !== 0  && links.map(({ id, link }) => (
                    <div key={id}>
                        <Link 
                        to={{ pathname: "/Contenido", state: { filtro_inicial: "tematicas", tematicas_inicial: link } }} 
                        className={styles.navLink}
                        smooth
                        duration={500}
                        onClick={() => {setNavBarOpen(false); setInput(""); setConsulta("");}}
                        >
                        {link}
                        </Link>
                        <div className={styles.border}></div>
                    </div>
                ))}
                {(!usuario || usuario.Tematicas.length === 0) && (
                    <div>
                        {links.map((item) => (
                            <MenuItem key={item.id} item={item} setNavBarOpen={setNavBarOpen} setInput={setInput} setConsulta={setConsulta}/>
                         ))}
                    </div>
                )}
                {usuario && ( <Link to="/mensajes" style={{color: 'var(--color-letras-nav)', paddingTop: "25px", fontweight: "400", fontsize: "1.2em"}} onClick={() => {setNavBarOpen(false); setInput(""); setConsulta("");}}> Mensajes <MdOutlineMail /></Link> )}
                {usuario && usuario.Tipo === "Cliente" && (<Link to="/compras" style={{color: 'var(--color-letras-nav)', fontweight: "400", fontsize: "1.2em"}}  onClick={() => {setNavBarOpen(false); setInput(""); setConsulta("");}}>Mis Compras <CiBoxList /></Link>)}
                {usuario && usuario.Tipo === "Tutor" && (<Link to="/ventas" style={{color: 'var(--color-letras-nav)', fontweight: "400", fontsize: "1.2em"}}  onClick={() => {setNavBarOpen(false); setInput(""); setConsulta("");}}>Mis Ventas <CiBoxList /></Link>)}
            </ul>
        )}
    </div>
  );
};

export default NavBar;


